export default __webpack_public_path__ + "static/media/success-color-icon.320eb3fe.svg";